<button
  [style.background-color]="resolvedBackgroundColor"
  (click)="onClickPressed()"
  [disabled]="disable"
>
  {{ text | translate }}
</button>
